import { Input } from "@heroui/react";
import { FilterCard } from "@/components/data-table";

const FilterData = ({ table, initialFilters }) => {
    const { filterPanel } = table;
    const { isOpen, pending, setPending, apply, clear } = filterPanel;

    const handleClear = () => {
        setPending(initialFilters);
        clear();
    };

    return (
        <FilterCard isVisible={isOpen} onClear={handleClear} onApply={apply}>
            {/* Nama Satuan */}
            <Input
                label="Nama Satuan"
                placeholder="Cari nama satuan..."
                value={pending.name || ""}
                onValueChange={(val) =>
                    setPending((prev) => ({
                        ...prev,
                        name: val,
                    }))
                }
                variant="flat"
                isClearable
            />
        </FilterCard>
    );
};

export default FilterData;
